angular.module('unica_invitation_transfer_event.invitation_transfer_event_services')

.factory('InvitationTransferEventCreateService', function ($http, getBaseApiURL) {
	
	var invitationTransferEventCreateService = {};

	invitationTransferEventCreateService.create = function ( invitationRoomData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-transfer-event/create',
			data: invitationRoomData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_transfer_event;
			}

		});

	};

	return invitationTransferEventCreateService;
});

